import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgAiMicrophone = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M9.085 15a6 6 0 0 0 11.83 0h2.02A8 8 0 0 1 16 21.936V24h-2v-2.064A8 8 0 0 1 7.064 15h2.021Z"
      fill={color}
    />
    <path
      d="M17 10a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0v-4Zm2 4a4 4 0 0 1-8 0v-4a4 4 0 0 1 8 0v4ZM4.297 3.588A5.205 5.205 0 0 0 7.589.297a.434.434 0 0 1 .822 0 5.205 5.205 0 0 0 3.292 3.291.434.434 0 0 1 0 .823 5.205 5.205 0 0 0-3.292 3.292.434.434 0 0 1-.822 0 5.205 5.205 0 0 0-3.292-3.292.434.434 0 0 1 0-.822ZM1.22 10.731a3.857 3.857 0 0 0 2.44-2.439.321.321 0 0 1 .61 0 3.857 3.857 0 0 0 2.439 2.44.321.321 0 0 1 0 .61 3.857 3.857 0 0 0-2.44 2.438.321.321 0 0 1-.61 0 3.857 3.857 0 0 0-2.44-2.439.321.321 0 0 1 0-.61Z"
      fill={color}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAiMicrophone);
export default ForwardRef;
